/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    Faculty,
    FacultyFromJSON,
    FacultyFromJSONTyped,
    FacultyToJSON,
} from './Faculty';
import {
    LaboratoryCategoryEnum,
    LaboratoryCategoryEnumFromJSON,
    LaboratoryCategoryEnumFromJSONTyped,
    LaboratoryCategoryEnumToJSON,
} from './LaboratoryCategoryEnum';
import {
    LaboratoryTypeEnum,
    LaboratoryTypeEnumFromJSON,
    LaboratoryTypeEnumFromJSONTyped,
    LaboratoryTypeEnumToJSON,
} from './LaboratoryTypeEnum';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface Laboratory
 */
export interface Laboratory {
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Laboratory
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Laboratory
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Laboratory
     */
    area?: number;
    /**
     * 
     * @type {number}
     * @memberof Laboratory
     */
    volume?: number;
    /**
     * 
     * @type {number}
     * @memberof Laboratory
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    name?: string | null;
    /**
     * 
     * @type {LaboratoryCategoryEnum}
     * @memberof Laboratory
     */
    category?: LaboratoryCategoryEnum;
    /**
     * 
     * @type {LaboratoryTypeEnum}
     * @memberof Laboratory
     */
    type?: LaboratoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    resources?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    facultyId?: string;
    /**
     * 
     * @type {Faculty}
     * @memberof Laboratory
     */
    faculty?: Faculty;
    /**
     * 
     * @type {string}
     * @memberof Laboratory
     */
    responsibleUserId?: string | null;
    /**
     * 
     * @type {AcademicUser}
     * @memberof Laboratory
     */
    responsibleUser?: AcademicUser;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof Laboratory
     */
    subjects?: Array<Subject> | null;
}

export function LaboratoryFromJSON(json: any): Laboratory {
    return LaboratoryFromJSONTyped(json, false);
}

export function LaboratoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Laboratory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'number': !exists(json, 'number') ? undefined : json['number'],
        'area': !exists(json, 'area') ? undefined : json['area'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'category': !exists(json, 'category') ? undefined : LaboratoryCategoryEnumFromJSON(json['category']),
        'type': !exists(json, 'type') ? undefined : LaboratoryTypeEnumFromJSON(json['type']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'resources': !exists(json, 'resources') ? undefined : json['resources'],
        'facultyId': !exists(json, 'facultyId') ? undefined : json['facultyId'],
        'faculty': !exists(json, 'faculty') ? undefined : FacultyFromJSON(json['faculty']),
        'responsibleUserId': !exists(json, 'responsibleUserId') ? undefined : json['responsibleUserId'],
        'responsibleUser': !exists(json, 'responsibleUser') ? undefined : AcademicUserFromJSON(json['responsibleUser']),
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
    };
}

export function LaboratoryToJSON(value?: Laboratory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'number': value.number,
        'area': value.area,
        'volume': value.volume,
        'capacity': value.capacity,
        'name': value.name,
        'category': LaboratoryCategoryEnumToJSON(value.category),
        'type': LaboratoryTypeEnumToJSON(value.type),
        'description': value.description,
        'resources': value.resources,
        'facultyId': value.facultyId,
        'faculty': FacultyToJSON(value.faculty),
        'responsibleUserId': value.responsibleUserId,
        'responsibleUser': AcademicUserToJSON(value.responsibleUser),
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
    };
}

